import { useId } from '@atlaskit/ds-lib/use-id';

// useId generates a number which cannot be used as an Id for html elements as is, therefore we need to prefix it with text.
export var usePrefixedUID = function usePrefixedUID() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'element';
  return "".concat(prefix, "-").concat(useId());
};